package io.eqoty.shared.devicelayer.functions

import io.eqoty.shared.devicelayer.DeviceAudioHandler

fun stopAudio() {
    DeviceAudioHandler.stop()
}